module.exports = __webpack_public_path__ + "img/Symbol.a9108615.svg";